<template>
    <g>
        <transition name="fade">
            <g>
                <g v-if="all_done">
                    <text
                        x="0"
                        y="-10"
                        class="txt"
                        text-anchor="middle"
                        dominant-baseline="middle"
                        font-family="sans-serif"
                        font-size="50"
                        fill="#000000"
                        >{{ text.allDone }}</text
                    >
                </g>
            </g>
        </transition>
    </g>
</template>

<script>
import { store } from "@/store.js";
import lang from "@/v/ordloopen/home/lang.js";
import { closeFullscreen } from "@/fullscreen.js";

export default {
    name: "menu_ordloopen",
    mixins: [lang],
    computed: {
        text() {
            return this.getLocalisedText();
        },
        all_done() {
            const progress = this.$store.state.progress;
            return (
                progress.math == 1 && progress.spatial == 1 && progress.digits == 1
            );
        },
    },
    mounted() {
        // Reset the task container the way the exit button does. test_span_digits
        // ends with the instructions shown and taskPhase 1, and test_span_spatial_linear
        // would otherwise start its instructions from that state and run them twice.
        store.commit("setTaskMode", "exit");

        const progress = this.$store.state.progress;

        if (progress.math != 1) {
            store.dispatch("gotoModule", "test_operation_span_math");
            return;
        }
        if (progress.digits != 1) {
            store.dispatch("gotoModule", "test_span_digits");
            return;
        }
        if (progress.spatial != 1) {
            store.dispatch("gotoModule", "test_span_spatial_linear");
            return;
        }

        // All tasks done: the template thanks the participant, who is free to close the tab.
        closeFullscreen();
    },
};
</script>
